import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1637.17647,1129.41176 L1524.23529,1129.41176 L1524.23529,1242.35294 C1586.46588,1242.35294 1637.17647,1292.95059 1637.17647,1355.29412 C1637.17647,1417.63765 1586.46588,1468.23529 1524.23529,1468.23529 L1411.29412,1468.23529 L1411.29412,1581.17647 C1473.52471,1581.17647 1524.23529,1631.77412 1524.23529,1694.11765 C1524.23529,1756.46118 1473.52471,1807.05882 1411.29412,1807.05882 L451.294118,1807.05882 C295.661176,1807.05882 168.941176,1680.45176 168.941176,1524.70588 L168.941176,903.529412 L275.557647,903.529412 C415.717647,903.529412 549.891765,845.929412 643.858824,745.750588 C778.484706,602.089412 937.28,379.256471 957.383529,112.941176 L993.750588,112.941176 C1044.23529,112.941176 1091.78353,135.303529 1124.08471,174.381176 C1156.72471,213.910588 1169.93882,265.524706 1160.22588,315.896471 C1137.52471,434.484706 1100.02824,551.943529 1048.97882,664.997647 C1025.14824,717.515294 1029.66588,777.6 1060.72471,825.938824 C1092.12235,874.503529 1145.43059,903.529412 1203.36941,903.529412 L1637.17647,903.529412 C1699.40706,903.529412 1750.11765,954.127059 1750.11765,1016.47059 C1750.11765,1078.81412 1699.40706,1129.41176 1637.17647,1129.41176 M1863.05882,1016.47059 C1863.05882,891.896471 1761.75059,790.588235 1637.17647,790.588235 L1203.36941,790.588235 C1183.71765,790.588235 1166.32471,781.214118 1155.70824,764.724706 C1145.31765,748.574118 1143.84941,729.148235 1151.86824,711.529412 C1206.53176,590.456471 1246.73882,464.414118 1271.24706,337.016471 C1287.17176,253.44 1265.37412,167.943529 1211.16235,102.437647 C1157.28941,37.3835294 1078.00471,2.84217094e-14 993.750588,2.84217094e-14 L846.588235,2.84217094e-14 L846.588235,56.4705882 C846.588235,310.927059 691.52,529.694118 561.524706,668.498824 C488.790588,745.976471 384.545882,790.588235 275.557647,790.588235 L56,790.588235 L56,1524.70588 C56,1742.68235 233.317647,1920 451.294118,1920 L1411.29412,1920 C1535.86824,1920 1637.17647,1818.69176 1637.17647,1694.11765 C1637.17647,1647.69882 1623.05882,1604.44235 1599.00235,1568.52706 C1686.87059,1537.58118 1750.11765,1453.66588 1750.11765,1355.29412 C1750.11765,1308.87529 1736,1265.61882 1711.94353,1229.70353 C1799.81176,1198.75765 1863.05882,1114.84235 1863.05882,1016.47059",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLikeLine = /*#__PURE__*/function (_Component) {
  _inherits(IconLikeLine, _Component);

  var _super = _createSuper(IconLikeLine);

  function IconLikeLine() {
    _classCallCheck(this, IconLikeLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconLikeLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLike",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLikeLine.displayName = "IconLikeLine";
  return IconLikeLine;
}(Component);

IconLikeLine.glyphName = 'like';
IconLikeLine.variant = 'Line';
IconLikeLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLikeLine;
export { IconLikeLine };